/**
 * Application wide constants
 */

export const DOCUMENT_LANG = document.documentElement.lang || 'nl';

// Media queries

export const MATCH_MEDIA = {
    xsup: matchMedia('(min-width: 0)'),
    smdown: matchMedia('(max-width: 599.98px)'),
    smup: matchMedia('(min-width: 600px)'),
    mddown: matchMedia('(max-width: 767.98px)'),
    mdup: matchMedia('(min-width: 768px)'),
    lgdown: matchMedia('(max-width: 991.98px)'),
    lgup: matchMedia('(min-width: 992px)'),
    xldown: matchMedia('(max-width: 1279.98px)'),
    xlup: matchMedia('(min-width: 1280px)'),
    xxldown: matchMedia('(max-width: 1439.98px)'),
    xxlup: matchMedia('(min-width: 1440px)'),
};
